import { scrollToFirstError } from '@jgile/laravel-vue/resources/js/util';
import FilePreview from '@jgile/laravel-vue/resources/js/components/FilePreview';
import Projection from './partials/Projection';
import Vue from 'vue';

Vue.component('create-asset', {
    props: {
        leadTimes: {
            required: true,
        },
    },
    components: {
        Projection,
        FilePreview,
    },
    data() {
        return {
            asset: new SparkForm({
                id: null,
                name: '',
                description: '',
                restock_modifier_type: 0,
                category_id: null,
                lead_time_id: 1,
                asset_type: 'simple',
                status: 0,
                asset_images: [],
                unit_increments: null,
                base_units_available: null,
                base_units_posted: null,
                restock: false,
                restock_threshold: null,
                restock_units_add: null,
                restock_reprice: false,
                restock_modifier_flat: null,
                restock_modifier_percent: null,
                rate_card: null,
                online_price: null,
                bundle_only: false,
                artwork_text: null,
                purchase_total_max_units: null,
                purchase_max_units: null,
                purchase_min_games: null,
                purchase_min_spend: null,
                purchase_min_units: null,
                purchase_min_weeks: null,
                artwork: null,
                demographics_metrics: null,
                creative_type: 0,
                creative_specs: [
                    {
                        height: null,
                        width: null,
                        creative_type: 0,
                    },
                ],
            }),
        };
    },
    computed: {
        previewMedia() {
            return _.get(this.asset, 'asset_images.0');
        },
        leadTime() {
            const _this = this;
            return _.find(this.leadTimes, (lt) => {
                return lt.id === _this.asset.lead_time_id;
            });
        },
        canAddPrices() {
            return (
                (this.asset.base_units_available && this.asset.base_units_posted && this.asset.online_price) ||
                (this.asset.base_units_available && this.asset.bundle_only && this.asset.online_price)
            );
        },
    },
    created() {
        this.asset.creative_specs = _.defaultTo(this.asset.creative_specs, {
            height: null,
            width: null,
        });
    },
    methods: {
        mediaModal(media) {
            Bus.$emit('openMediaModal', {
                media: media,
                size: 'lg',
            });
        },
        setProjection(newVal, key) {
            if (!_.has(this.asset, `asset_images[${key}].custom_properties.projection`)) {
                _.set(this.asset, `asset_images.${key}.custom_properties`, {});
                _.set(this.asset, `asset_images.${key}.custom_properties.projection`, {});
            }

            _.set(this.asset, `asset_images.${key}.custom_properties.projection`, newVal);
        },
        saveAndPrepare() {
            this.asset.status = 1;
            this.saveAsset();
        },
        saveAsset() {
            const _this = this;

            if (!this.asset.restock) {
                this.asset.restock_threshold = null;
                this.asset.restock_units_add = null;
                this.asset.restock_reprice = 0;
                this.asset.restock_modifier_percent = null;
                this.asset.restock_modifier_flat = null;
            }

            Spark.post('/api/team/assets', this.asset)
                .then((response) => {
                    _this.$noty.success('Asset created');
                    let asset = _this.$vueData.getData(response);
                    window.location = '/team/assets/' + asset.id + '/edit';
                })
                .catch(() => {
                    scrollToFirstError();
                });
        },
    },
});
